var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KnownContext } from '@spotify-internal/remote-config-core';
import { getLogger } from '@spotify-internal/remote-config-common';
const logger = getLogger('middleware:session-config');
export const sessionConfig = next => () => {
    let config = null;
    let configHash = '';
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        const hash = KnownContext.hash(ctx);
        if (configHash === hash) {
            logger.debug('Session matching hash: "%s" will be used. %o', hash, config);
            return config;
        }
        config = yield next(ctx);
        logger.debug('Setting session hash: "%s"', hash);
        configHash = hash;
        return config;
    });
};
//# sourceMappingURL=sessionConfig.js.map